import React from "react"
import { Link } from "gatsby"
import Cookies from "js-cookie"
import PropTypes from "prop-types"

const AgeOverlay = (props) => {
  const consented = props.consented;

  if (!consented && !navigator?.userAgent.toLowerCase().includes(`googlebot`)) {
    return(
      <div className="flex w-full h-full fixed block top-0 left-0 bg-gray-600 z-50 text-center">
        <div className="m-auto px-2 md:w-1/2">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Water and Power</h1>
          <h2 className="text-4xl md:text-6xl font-bold mb-2">Age Verification</h2>
          <h2 className="text-4xl md:text-6xl font-bold mb-2">Cookie Consent</h2>
          <p className="md:text-xl mt-4">
            Water and Power is an adult community that contains sexually explicit content.
            You must be 18 years old or over to enter.
          </p>

          <p className="md:text-xl mt-4">
            Cookies help us deliver our services. Water and Power uses cookies and data to give you the best personalized Water and Power experience possible.
          </p>

          <p className="md:text-xl mt-4">
            We respect your right to privacy and offer you full transparency and control if you prefer not to allow certain types of cookies.
          </p>

          <p className="md:text-xl mt-4">
            Disabling cookies will usually result in disabling and/or malfunctioning of certain functions and features of Water and Power.
            Therefore it is recommended that you do not disable cookies.
          </p>
          <div
            className="mt-4 flex flex-row w-full">
            <Link
              to="/"
              onClick={() => { Cookies.set('consented', true, { expires: 365 }); document.location.reload(); }}
              className="rounded-sm text-center w-full py-3 font-bold text-white text-xl md:text-3xl bg-[#ffc439] hover:bg-black transition-all duration-300 ease-in-out"
              id="consent"
            >
              I am over 18 and accept cookies
            </Link>
          </div>
          <div className="mt-4">
            © {new Date().getFullYear()}
            <span>
              &nbsp;
              Water and Power
            </span>
          </div>
        </div>
      </div>
    )
  }
}

AgeOverlay.propTypes = {
  consented: PropTypes.bool,
}

export default AgeOverlay
